import { Typography } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2/Grid2'
import { ArrowCircleLeft, ArrowCircleRight, PhotoCameraFront } from '@mui/icons-material'
import person from '../../../Assets/Imgs/person.png'

const style = {
    typographyStyle: {
        fontWeight: 600,
        fontSize: '10px',
        textAlign: 'start',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    imgStyle: {
        height: '26px',
        width: '26px',
        borderRadius: '5px'
    }
}

const CardDiscreto = ({ acesso, openVideoFunction, idCentral }) => {
    const { id, data, funcao, nome, descAcesso, evento, img_perfil, ids_camera_gravacao, sentido } = acesso

    const isMorador = ['MORADOR', 'Proprietário(a)', 'Família', 'Responsável', 'Filho(a)', 'Esposa(o)', 'Sindico (AppOne)', 'Proprietario (AppOne)'].includes(funcao)
    const color = evento == 'OANG' ? '#FF0000' : isMorador ? '#0FBB00' : '#FB9B0C'

    const imgPerfil = `${window.location.origin.replace(':3003', '')}/wsOnePortaria/web/images/${img_perfil}?${new Date().getTime()}`
    const imgTag = `${window.location.origin.replace(':3003', '')}/wsOnePortaria/web/images/${idCentral}/f${acesso.cd_acesso}.jpg?${new Date().getTime()}`

    const img = img_perfil ? imgPerfil : imgTag

    const id_camera = (ids_camera_gravacao) ? ids_camera_gravacao.split(',')[0] : ''

    return (
        <Grid
            container
            sx={{
                border: `2px solid ${color}`,
                borderRadius: '5px',
                height: '34px',
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignContent: 'center',
                padding: '1px',
                backgroundColor: '#A8A4AB'
            }}
            gap={1}
        >
            <Grid
                item
                container
                sx={{
                    width: '63px',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'start',
                    alignContent: 'center',
                    flexDirection: 'row',
                    padding: 0,
                    margin: 0
                }}
                gap={1}
            >
                <img key={`${nome}-img`} style={style.imgStyle} src={img} onError={(e) => {
                    e.target.onerror = (e) => {
                        console.log(e.target.src)
                        e.target.onerror = null
                        e.target.src = person
                    }
                    e.target.src = imgTag
                }} />

                <PhotoCameraFront
                    sx={{ color: (id_camera ? 'black' : 'gray'), cursor: (id_camera ? 'pointer' : ''), ...style.imgStyle }}
                    onClick={() => id_camera ? openVideoFunction(id, id_camera) : null}
                />
            </Grid>
            <Grid item container style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignContent: 'center',
                flexDirection: 'row',
                height: '100%',
                width: 'calc(100% - 80px)',
                flexWrap: 'noWrap'
            }}
            gap={1}
            >
                <Grid item sx={{
                    width: '25%',
                    overflow: 'hidden',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <Typography sx={style.typographyStyle} titleaccess={data} >{data}</Typography>
                </Grid>
                <Grid item sx={{
                    width: '25%',
                    overflow: 'hidden',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <Typography sx={style.typographyStyle} titleaccess={funcao} >{isMorador ? 'Usuário' : 'Visitante'}</Typography>
                </Grid>
                <Grid item sx={{
                    width: '25%',
                    overflow: 'hidden',
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center'
                }}>
                    <Typography sx={style.typographyStyle} titleaccess={nome} >{nome}</Typography>
                </Grid>
                <Grid item sx={{
                    width: '25%',
                    overflow: 'hidden',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <Typography sx={{ ...style.typographyStyle, display: 'flex', justifyContent: 'center', gap: 1 }} >
                        {descAcesso}{sentido && <span style={{ display: 'flex', justifyContent: 'center' }}>
                            {sentido == 'E' ? <ArrowCircleRight sx={{ fontSize: '17px', color: '#027502' }} /> : <ArrowCircleLeft sx={{ fontSize: '17px', color: '#c70505' }} />}
                        </span>
                        }
                    </Typography>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default CardDiscreto
